import { render, staticRenderFns } from "./DumbappArgumentView.vue?vue&type=template&id=a7d4ba96&"
import script from "./DumbappArgumentView.vue?vue&type=script&lang=ts&"
export * from "./DumbappArgumentView.vue?vue&type=script&lang=ts&"
import style0 from "./DumbappArgumentView.vue?vue&type=style&index=0&id=a7d4ba96&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports